import {
  resolveRazaEventVenueAddress,
  type RazaEventHallBookingVenueLine,
  type RazaEventVenueSource,
  type ResolvedRazaEventVenueAddress,
} from "./raza-event-venue-address";

export type RazaEventVenueRecordInput = {
  address?: string | null;
  hallBookings?: RazaEventHallBookingVenueLine[] | null;
  /** Host ITS directory address when hydrated on the record. */
  hostAddress?: string | null;
};

export type RazaEventVenueDisplay = {
  value: string;
  hint: string | null;
  source: RazaEventVenueSource;
};

function trimStr(v: unknown): string {
  if (v == null) return "";
  return String(v).trim();
}

/** Short read-only hint for where the effective venue came from. */
export function razaEventVenueSourceHint(source: RazaEventVenueSource): string | null {
  switch (source) {
    case "hall":
      return "Linked hall venue";
    case "manual":
      return "Manual override";
    case "its":
      return "From host ITS directory";
    default:
      return null;
  }
}

export function resolveRazaEventVenueFromRecord(
  record: RazaEventVenueRecordInput
): ResolvedRazaEventVenueAddress {
  return resolveRazaEventVenueAddress({
    storedAddress: record.address,
    hallBookings: record.hallBookings,
    itsAddress: record.hostAddress,
  });
}

/** Effective venue for read-only UI (`—` when empty). */
export function formatRazaEventVenueForDisplay(
  resolved: ResolvedRazaEventVenueAddress
): RazaEventVenueDisplay {
  return {
    value: resolved.value.length > 0 ? resolved.value : "—",
    hint: razaEventVenueSourceHint(resolved.source),
    source: resolved.source,
  };
}

export type BookingHallLineVenueInput = {
  hallName?: string | null;
  hall?: { name?: string | null; venue?: string | null } | null;
};

/** Venue cell for a booking hall line: hall venue when set, else hall name. */
export function resolveBookingHallLineVenue(hall: BookingHallLineVenueInput): string {
  const venue = trimStr(hall.hall?.venue);
  if (venue.length > 0) return venue;
  return trimStr(hall.hallName) || trimStr(hall.hall?.name);
}
